export const GET_CART = 'GET_CART';
// export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
// export const GET_CART_FAIL = "GET_CART_FAIL";

// export const SET_CART_DATA = "SET_CART_DATA";
